import React, { Component } from 'react';

export default class PaginationPage extends Component {
  handleClick = (e) => {
    e.preventDefault();
    this.props.onPageClick(this.props.page);
  }

  render() {
    return (
      <a href="#" onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}
